import { Box, BoxProps, Icon, Text, TextProps } from '@jfs/ui-new'
import { useState } from 'react'
import ReactDOM from 'react-dom'
import { ModBox } from '../../comps/ModifiedBox/ModifiedBox'

interface TooltipViewProps {
  value: any
  alignLeft?: any
}

const TooltipView = ({ value, alignLeft = false }: TooltipViewProps) => {
  const [toolTipInfo, setToolTipInfo] = useState({ visible: false, top: 0, right: 40, left: 0 })
  const [layoutEvent, setLayoutEvent] = useState<any>({})

  const renderTooltip = () => {
    return (
      <Box
        testID="tooltip-view"
        top={toolTipInfo.top}
        left={alignLeft ? toolTipInfo.left : undefined}
        right={!alignLeft ? toolTipInfo.right : undefined}
        {...styles.shadowStyle}>
        <Text {...styles.text}>{value}</Text>
      </Box>
    )
  }
  return (
    <>
      <Box
        paddingLeft={6}
        underlayColor="TRANSPARENT"
        onLayout={(event: any) => {
          setLayoutEvent(event.nativeEvent)
          setToolTipInfo({
            ...toolTipInfo,
            top: event.nativeEvent.layout?.top + 20,
            left: event.nativeEvent.layout?.left,
          })
        }}
        onHover={(hovered: any) => {
          layoutEvent?.target?.measure((...args: any) => {
            setToolTipInfo({ ...{ ...toolTipInfo, top: args[5] + 20, left: args[4] }, visible: hovered })
          })
        }}
        testID="show-tooltip"
        onPress={() => {
          setToolTipInfo({ ...toolTipInfo, visible: !toolTipInfo.visible })
        }}>
        <Icon id="INFO" size={12} color="DARK_GREY" />
      </Box>
      <ModBox show={toolTipInfo.visible} position="absolute">
        {ReactDOM.createPortal(renderTooltip(), document.body)}
      </ModBox>
    </>
  )
}

const styles = {
  shadowStyle: {
    position: 'absolute',
    shadowOffset: { width: 1, height: 1 },
    shadowRadius: 2,
    shadowColor: 'GREY_MATTE',
    borderRadius: 4,
    borderWidth: 0.5,
    borderColor: 'BRAND_COLOR_GRAY_3',
    zIndex: 5,
    backgroundColor: 'WHITE',
    padding: 16,
  } as BoxProps,
  text: {
    fontSize: 12,
    color: 'BLACK_21',
    fontWeight: 'BOLD',
  } as TextProps,
}

export { TooltipView }
